import React from 'react';
import { Select } from 'antd';
import { usePaymentStates } from '../../api/paymentStatesQuery';

const { Option } = Select;

const SelectPaymentState = ({
  mode = 'multiple',
  allowClear = true,
  value,
  onChange,
  ...props
}) => {
  const { data, isFetching } = usePaymentStates({
    staleTime: Infinity,
    notifyOnChangeProps: ['data', 'isFetching'],
  });

  const states = data?.paymentState;

  const statesSet = new Set(states?.map((state) => state.id) || []);

  const validVal = statesSet.size
    ? (value || []).filter((v) => statesSet.has(v))
    : [];

  return (
    <Select
      {...props}
      loading={isFetching}
      mode={mode}
      allowClear={allowClear}
      placeholder="Статус оплаты"
      value={validVal}
      onChange={onChange}
      optionFilterProp="searchtext"
    >
      {states?.map((state) => (
        <Option
          key={state.id}
          value={state.id}
          searchtext={state.name}
        >
          {state.name}
        </Option>
      ))}
    </Select>
  );
};

export default SelectPaymentState;
